import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Auth, Storage } from 'aws-amplify';

@Component({
  selector: 'app-s3-image-main',
  templateUrl: './s3-image-main.component.html',
  styleUrls: ['./s3-image-main.component.scss']
})
export class S3ImageMainComponent implements OnInit {

  @ViewChild('el') el:ElementRef
  @Input('key') key:string

  constructor() { }

  ngOnInit(): void {
    this.getUrl()
  }

  src:any
  async getUrl() {
    //console.log(this.key)
    const src = await Storage.get(this.key, {customPrefix: {public: ''}})
    this.src = src
    //console.log( this.src)
  }

}
